import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

/**
 * Universal employee avatar.
 * - Accepts either `avatar_url` (backend canonical) or `profile_picture` (legacy)
 * - Falls back to gradient-initials avatar when no photo is available
 * - Pass `e` (employee/user object) and optional sizing class
 */
export function getEmpPhoto(e) {
  if (!e) return null;
  return e.avatar_url || e.profile_picture || e.photo_url || null;
}

export function initials(name = "") {
  return name.split(" ").filter(Boolean).slice(0, 2).map((p) => p[0]?.toUpperCase()).join("") || "U";
}

export default function EmpAvatar({ e, name, photo, className = "w-9 h-9", gradient = "from-violet-500 to-fuchsia-500" }) {
  const img = photo || getEmpPhoto(e);
  const display = name || e?.full_name || "User";
  return (
    <Avatar className={`${className} shrink-0`}>
      {img && <AvatarImage src={img} alt={display} />}
      <AvatarFallback className={`bg-gradient-to-br ${gradient} text-white font-semibold`}>
        {initials(display)}
      </AvatarFallback>
    </Avatar>
  );
}
